export default "__VITE_ASSET__DeCg31er__"